import AuditorTransactionsScreen from './AuditorTransactionsScreen';
export default AuditorTransactionsScreen;
